var _text, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgParentCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Final_Vertical_White_2",
    "data-name": "Final Vertical White 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 185,
    height: 42,
    viewBox: "0 0 185 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "QuillHash",
    transform: "translate(48 31)",
    fill: "#fff",
    fontSize: 31,
    fontFamily: "Visby CF",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "QuillHash"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "QuillHash-2",
    "data-name": "QuillHash",
    transform: "translate(0 3.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M22.2,52.441a30.53,30.53,0,0,1,1.446-3.675A58.251,58.251,0,0,1,32.188,36.3,71.814,71.814,0,0,1,46.912,23.571a31.861,31.861,0,0,1,7.625-3.806c.131-.131.394-.131.657-.262l-1.578,1.969a61.533,61.533,0,0,0-5,6.561c-.131.262-.263.262-.526.262a14.316,14.316,0,0,1-3.42.524,4.168,4.168,0,0,0,1.578,1.05c.263.131.788.131.92.525,0,.262-.394.656-.526.919A1.894,1.894,0,0,1,45.2,32.494a13.239,13.239,0,0,1-3.287.525c0,.262.131.262.263.394a7.313,7.313,0,0,0,2.235,1.181c.263.131.263.262.131.525a1.744,1.744,0,0,1-1.446,1.05,23.742,23.742,0,0,1-5.127,1.05h-.131a7.223,7.223,0,0,0,1.183.919,14.034,14.034,0,0,0,2.5.919c.131,0,.263.131.131.263a10.14,10.14,0,0,1-2.235,2.493,2.992,2.992,0,0,1-2.366.656H34.028a14.314,14.314,0,0,0-2.366.131,2.439,2.439,0,0,0-1.578.919A24.072,24.072,0,0,0,27.06,48.5l-.394.787a2.782,2.782,0,0,1-1.84,1.969A9.07,9.07,0,0,0,22.2,52.44Z",
    transform: "translate(-12.028 -19.503)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "<",
    transform: "translate(0 29.304)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&lt;")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": ">",
    transform: "translate(21.176 33.748)",
    fill: "#fff",
    fontSize: 19,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "&gt;")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentCompany);
export default __webpack_public_path__ + "static/media/parentCompany.f6a8e4058b28b7e735e2229edb295625.svg";
export { ForwardRef as ReactComponent };